/**
 * InstallBanner — the one-time "Add to Home Screen" banner (§7.9). The shell
 * shows it only when the browser offered an install prompt and the banner
 * hasn't been dismissed; the gear menu's InstallGuide is the other install path.
 */

import { PillButton } from "./PillButton";

export interface InstallBannerProps {
  onInstall: () => void;
  onDismiss: () => void;
}

export function InstallBanner({ onInstall, onDismiss }: InstallBannerProps) {
  return (
    <section
      data-testid="install-banner"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        padding: "12px 16px",
        background: "var(--mark-bg-surface)",
        border: "1px solid var(--mark-border-default)",
        borderRadius: "12px",
      }}
    >
      <span>Add Mark to your home screen for one-tap, offline capture.</span>
      <span style={{ display: "flex", gap: "8px" }}>
        <PillButton
          size="sm"
          data-testid="install-banner-accept"
          style={{ padding: "0 20px" }}
          onClick={onInstall}
        >
          Install
        </PillButton>
        <button
          type="button"
          data-testid="install-banner-dismiss"
          style={{
            minHeight: "44px",
            border: "none",
            borderRadius: "22px",
            padding: "0 20px",
            background: "none",
            color: "var(--mark-text-muted)",
            fontFamily: "inherit",
            cursor: "pointer",
          }}
          onClick={onDismiss}
        >
          Not now
        </button>
      </span>
    </section>
  );
}
